import { SpecificationCategoriesManager } from '@/components/specifications/SpecificationCategoriesManager';

export default function AdminSpecificationCategoriesPage() {
  return (
    <div className="container mx-auto p-6 max-w-7xl">
      <SpecificationCategoriesManager />
    </div>
  );
}
